"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDefaultIndicatorSection = void 0;
const tslib_1 = require("tslib");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const dotty = require('dotty');
function makeDefaultIndicatorSection(db, patients, sectionSchema) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const indicator = sectionSchema.indicator;
        if (!((_a = db.get.readings) === null || _a === void 0 ? void 0 : _a[indicator])) {
            throw new Error(`invalid indicator with value ${indicator} passed to makeDefaultIndicatorSection. stringified sectionSchema is:\n${JSON.stringify(sectionSchema)}`);
        }
        const sectionStructure = defaultIndicatorSectionStructure(indicator);
        const subtitles = sectionStructure.subtitles.map((accessor) => accessor.subtitle);
        const data = [];
        for (const patient of patients) {
            const readings = yield db.get.readings[indicator].forUser(patient._id);
            for (const reading of readings) {
                data.push(makeDefaultIndicatorSectionRow(reading, sectionStructure, !!((_b = sectionSchema === null || sectionSchema === void 0 ? void 0 : sectionSchema.options) === null || _b === void 0 ? void 0 : _b.statusAsNumber)));
            }
        }
        return {
            title: sectionStructure.title,
            type: 'indicator',
            indicator,
            subtitles,
            data,
        };
    });
}
exports.makeDefaultIndicatorSection = makeDefaultIndicatorSection;
function makeDefaultIndicatorSectionRow(reading, sectionStructure, statusAsNumber) {
    const entry = {};
    for (const subtitle of sectionStructure.subtitles) {
        entry[subtitle.subtitle] = dotty.get(reading, subtitle.accessor);
        if (subtitle.status && !statusAsNumber)
            entry[subtitle.subtitle] = statusNumToString(entry[subtitle.subtitle]);
    }
    return entry;
}
function defaultIndicatorSectionStructure(indicator) {
    const startingSubtitles = [
        { subtitle: 'ID of reading', accessor: ['_id'] },
        { subtitle: 'Aetonix Patient ID', accessor: ['who'] },
    ];
    const endingSubtitles = [
        { subtitle: 'Manually Entered?', accessor: ['history', 'manual'] },
        { subtitle: 'Comment', accessor: ['history', 'comment'] },
        { subtitle: 'Created At', accessor: ['created_at'] },
        { subtitle: 'Updated At', accessor: ['updated_at'] },
    ];
    let middleSubtitles = [];
    let title;
    if (indicator === 'activity') {
        title = 'Steps';
        middleSubtitles = [
            { subtitle: 'Number of steps', accessor: ['history', 'value'] },
            { subtitle: 'Cumulative', accessor: ['cumulative'] },
            { subtitle: 'Status', accessor: ['status'], status: true },
        ];
    }
    else if (indicator === 'bloodoxygen') {
        title = 'Blood Oxygen';
        middleSubtitles = [
            { subtitle: 'Pulserate', accessor: ['history', 'pulserate'] },
            {
                subtitle: 'Oxygen Saturation',
                accessor: ['history', 'oxygensaturation'],
            },
            { subtitle: 'Oxygen', accessor: ['history', 'oxygen'] },
            { subtitle: 'Exertion', accessor: ['history', 'exertion'] },
            {
                subtitle: 'Status of Heart Rate',
                accessor: ['history', 'heartRateStatus'],
                status: true,
            },
            {
                subtitle: 'Status of Oxygen Saturation',
                accessor: ['history', 'oxygenSaturationStatus'],
                status: true,
            },
        ];
    }
    else if (indicator === 'bloodpressure') {
        title = 'Blood Pressure';
        middleSubtitles = [
            { subtitle: 'Systolic', accessor: ['history', 'systolic'] },
            { subtitle: 'Diastolic', accessor: ['history', 'diastolic'] },
            {
                subtitle: 'BP Pulserate',
                accessor: ['history', 'pbpPulserateulserate'],
            },
            {
                subtitle: 'Status of BP Pulserate',
                accessor: ['history', 'bpPulserateStatus'],
                status: true,
            },
            { subtitle: 'Status', accessor: ['history', 'status'], status: true },
            { subtitle: 'Units', accessor: ['history, units'] },
        ];
    }
    else if (indicator === 'bloodsugar') {
        title = 'Blood Sugar';
        middleSubtitles = [
            { subtitle: 'Mean Blood Level', accessor: ['history', 'meanblood'] },
            { subtitle: 'mmol', accessor: ['history', 'mmol'] },
            { subtitle: 'mg', accessor: ['history', 'mg'] },
            { subtitle: 'Status', accessor: ['history', 'status'], status: true },
            { subtitle: 'Units', accessor: ['history', 'units'] },
        ];
    }
    else if (indicator === 'bodytemperature') {
        title = 'Body Temperature';
        middleSubtitles = [
            { subtitle: 'Celsius', accessor: ['history', 'celsius'] },
            { subtitle: 'Farenheit', accessor: ['history', 'farenheit'] },
            { subtitle: 'Status', accessor: ['history', 'status'], status: true },
            { subtitle: 'Units', accessor: ['history', 'units'] },
        ];
    }
    else if (indicator === 'weight') {
        title = 'Weight';
        middleSubtitles = [
            { subtitle: 'Pounds', accessor: ['history', 'lbs'] },
            { subtitle: 'Kilograms', accessor: ['history', 'kg'] },
            { subtitle: 'Status', accessor: ['history', 'status'] },
            { subtitle: 'Units', accessor: ['history', 'units'] },
        ];
    }
    else {
        throw new Error(`Illegal type passed to getSubttilesForIndicator. Received type was ${indicator}`);
    }
    return {
        subtitles: startingSubtitles
            .concat(middleSubtitles)
            .concat(endingSubtitles),
        title,
    };
}
function statusNumToString(num) {
    if (num < 0) {
        return 'No Status';
    }
    else if (num === 0) {
        return 'No Risk (Green)';
    }
    else if (num === 1) {
        return 'Low Risk (Yellow)';
    }
    else if (num === 2) {
        return 'High Risk (Red)';
    }
    return num;
}
//# sourceMappingURL=defaultIndicatorSection.js.map